import React, { useEffect, useMemo, useState } from 'react';
import { IMedication, ISpecialty } from 'types/operation';
import s from './s.module.less';
import { Button } from 'antd';
import cx from 'classnames';

interface IProps {
    previewList?: ISpecialty[];
}

const MedicationPreview: React.FC<IProps> = ({ previewList }) => {
    const [selectedSpecialtyId, setSelectedSpecialtyId] = useState<number>();
    const [previewData, setPreviewData] = useState<ISpecialty[]>([]);

    useEffect(() => {
        if (previewList) {
            setPreviewData(previewList.filter((spec) => spec.medications && spec.medications.length > 0));
        }
    }, [previewList]);

    const selectedSpecialty = useMemo(() => previewData?.find((spec) => spec.id === selectedSpecialtyId), [previewData, selectedSpecialtyId]);

    const handleLinkClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
    };

    useEffect(() => {
        setSelectedSpecialtyId(previewData?.[0]?.id);
    }, [previewData]);

    return (
        <div className={s.previewContainer}>
            <div className={s.header}>
                <h2 className={s.title}>Get a prescription — 500+ options available</h2>
                <a href="#" className={s.viewAllLink} onClick={handleLinkClick}>
                    View all medications →
                </a>
            </div>

            <div className={s.specialties}>
                {previewData?.sort((a, b) => (a.specialtyPriority || 0) - (b.specialtyPriority || 0)).map((specialty) => (
                    <div
                        key={specialty.id}
                        className={cx(s.specialtyTab, { [s.active]: specialty.id === selectedSpecialtyId })}
                        onClick={() => setSelectedSpecialtyId(specialty.id)}
                    >
                        {specialty.specialtyName}
                    </div>
                ))}
            </div>

            <div className={s.medicationGrid}>
                {selectedSpecialty?.medications?.map((medication: IMedication) => (
                    <div key={medication.id} className={s.medicationCard}>
                        <div className={s.cardContent}>
                            <div>
                                <h3 className={s.medicationTitle}>{medication.title || '-'}</h3>
                                <p className={s.medicationSubtext}>{medication.subtext || '-'}</p>
                            </div>
                        </div>
                        <div className={s.imageContainer}>
                            {medication.imageUrl ? <img src={medication.imageUrl} alt={medication.tag} className={s.medicationImage} /> : <div className={s.imagePlaceholder}>-</div>}
                        </div>
                        <Button type="primary" ghost className={s.prescriptionButton}>
                            Get a prescription
                        </Button>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default MedicationPreview;
